import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLanguageContext } from "~/context/language";
import { Button } from "~/atoms/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "~/atoms/dropdown-menu";
import { languages, getLangLabels } from "~/i18n";

export function LanguageSelector() {
  const { t } = useTranslation();
  const { language, setLanguage } = useLanguageContext();

  const langLabel = getLangLabels(t);

  return (
    <div className="z-10">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline">
            <Languages className="size-4" />
            {t(($) => $.commons.language)}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuRadioGroup value={language} onValueChange={setLanguage}>
            {Object.values(languages).map((lang) => (
              <DropdownMenuRadioItem key={lang.code} value={lang.code}>
                {langLabel[lang.code]}
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
